module.exports = __webpack_public_path__ + "img/44.0e5a8662.jpg";